import { RAID_METADATA_BY_SLUG, SEASONS_BY_SLUG } from './enums';

export function isExpansionFeatureAllowed(
  expansionId: number | null | undefined,
  minimumExpansionId: number | null | undefined
) {
  return !!expansionId && !!minimumExpansionId && expansionId >= minimumExpansionId;
}

export function isRaidFeatureAllowed(raidSlug: string | null | undefined, minimumExpansionId: number | null | undefined) {
  if (!raidSlug) {
    return false;
  }

  return isExpansionFeatureAllowed(RAID_METADATA_BY_SLUG[raidSlug]?.expansion, minimumExpansionId);
}

export function isSeasonFeatureAllowed(
  seasonSlug: string | null | undefined,
  minimumExpansionId: number | null | undefined
) {
  if (!seasonSlug) {
    return false;
  }

  return isExpansionFeatureAllowed(SEASONS_BY_SLUG.get(seasonSlug)?.expansionId, minimumExpansionId);
}
